import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, FirestoreService } from '../service.index';
import { switchMap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardGuard implements CanActivate {

  constructor(public authService: AuthService, public router: Router, private afs: FirestoreService){}

  canActivate(): boolean {

    console.log('Paso por el Login Guard');

    return this.authService.isAuth().pipe(
      map(user => {


        if (user) {
          console.log("user login");
          return true;
        } else {
          console.log("no logged");
          this.router.navigate(['/login']);
          return false;
        }
      }))

  }

}
